/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Review_Category_ConsistencyInputs */

const en_cv_review_category_consistency = /** @type {(inputs: Cv_Review_Category_ConsistencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consistency`)
};

const de_cv_review_category_consistency = /** @type {(inputs: Cv_Review_Category_ConsistencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsistenz`)
};

/**
* | output |
* | --- |
* | "Consistency" |
*
* @param {Cv_Review_Category_ConsistencyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_review_category_consistency = /** @type {((inputs?: Cv_Review_Category_ConsistencyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Review_Category_ConsistencyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_review_category_consistency(inputs)
	return en_cv_review_category_consistency(inputs)
});